import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Icon from 'components/shared/Icon'
import { FamilyDot, FamilyPackageElementWrapper } from './styles'
import { FormattedMessage } from 'react-intl'
import { capitalize } from 'lodash'
import { getExpiryDate } from 'helpers/helpers'

interface FamilyPackageElementInterface {
    type: 'ticket' | 'voucher'
    quantity: number
    description: string
    length?: number
    zone?: string
    time?: string
}

export const FamilyPackageElement = ({
    type,
    quantity,
    length,
    description,
    zone,
    time,
}: FamilyPackageElementInterface) => (
    <>
        {type === 'ticket' && (
            <FamilyPackageElementWrapper
                isFullWidth
                direction={['column', 'row']}
                align={['flex-start', 'center']}
                justify="space-between"
                gap={[8, 0]}
            >
                <Box direction="row" align="center" gap={8}>
                    <Text variant="bodySmall" color="grayscale_700">
                        {quantity}x
                    </Text>
                    <Box direction="row" align="center" gap={4}>
                        <Icon variant="ticket" color="secondary_500" />
                        <Text variant="bodySmall" color="grayscale_900">
                            {description}
                        </Text>
                        {!!length && length > 1 && (
                            <Text variant="bodySmall" color="grayscale_700">
                                <FormattedMessage
                                    id="package.family.ticket_days"
                                    defaultMessage="({amount} dni)"
                                    values={{
                                        amount: length,
                                    }}
                                />
                            </Text>
                        )}
                    </Box>
                </Box>
                <Box direction="row" align="center" gap={[8, 16]}>
                    {!!zone && (
                        <Box direction="row" align="center" gap={4}>
                            <Text variant="bodySmall" color="grayscale_700">
                                <FormattedMessage
                                    id="package.family.zone"
                                    defaultMessage="Strefa"
                                />
                                :
                            </Text>
                            <Text variant="bodySmall" color="grayscale_900">
                                {capitalize(zone)}
                            </Text>
                        </Box>
                    )}
                    {!!(zone && time) && <FamilyDot />}
                    {!!time && (
                        <Text variant="bodySmall" color="grayscale_900">
                            {time}
                        </Text>
                    )}
                </Box>
            </FamilyPackageElementWrapper>
        )}
        {type === 'voucher' && (
            <FamilyPackageElementWrapper
                isFullWidth
                direction={['column', 'row']}
                align={['flex-start', 'center']}
                justify="space-between"
                gap={[8, 0]}
            >
                <Box direction="row" align="center" gap={8}>
                    <Text variant="bodySmall" color="grayscale_700">
                        {quantity}x
                    </Text>
                    <Box direction="row" align="center" gap={4}>
                        <Icon variant="ticket-2" color="secondary_500" />
                        <Text variant="bodySmall" color="grayscale_900">
                            {description}
                        </Text>
                    </Box>
                </Box>
                <Box direction="row" align="center" gap={4}>
                    <Text variant="bodySmall" color="grayscale_700">
                        <FormattedMessage
                            id="package.family.valid"
                            defaultMessage="Data ważności"
                        />
                        :
                    </Text>
                    <Text variant="bodySmall" color="grayscale_900">
                        {getExpiryDate({ length: 12, unit: 'month' })}
                    </Text>
                </Box>
            </FamilyPackageElementWrapper>
        )}
    </>
)
